export default __webpack_public_path__ + "static/media/community-events-banner.b23b6035.png";